<template>
  <div class="useSlideBox">
    <el-carousel
      :height="slideHeight + 'px'"
      :autoplay="false"
      :initial-index="parseInt(onSlide)"
    >
      <el-carousel-item v-for="(item, idx) in slideList" :key="idx">
        <el-image class="imgBox" fit="cover" :src="item.PicUrl"></el-image>
        <div class="slideInfo">
          <h3>{{ item.Title }}</h3>
          <p v-html="changeValue(item.Summary)"></p>
          <!-- <p>{{ item.info2 }}</p> -->
          <div class="zixun" v-if="lang=='zh'">
            <a href="javascript:;"
              >购买与咨询
              <img src="@/assets/img/icon_wx1.png" alt="" class="i1" />
              <img src="@/assets/img/icon_wx2.png" alt="" class="i2" />
            </a>
            <div class="qrcode" v-if="item.QrCodePicUrl">
              <img :src="item.QrCodePicUrl" alt="" />
              <div class="txt">
                使用微信"扫一扫”<br />
                <div
                  class="txt2"
                  v-html="item.ContactInfo.replace(/\n/g, '<br>')"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { changeText } from "@/utils/tool";
export default {
  data() {
    return {
      slideHeight: 580,
      list: [
        {
          url: require("@/assets/images/useSlide01.jpg"),
          name: "航空航天",
          info: "航空航天苛刻的使用环境对结构材料的拉伸性能、压缩性能、抗冲击、疲劳等性能有极高的要求，在航空领域，碳纤维复合材料主要应用于飞机的结构材料（占飞机重量的30%左右），可以使飞机结构材料减重20%至40%，飞机整体重量减轻6%至12%，从而显著地降低飞机的燃油成本。",
          info2:
            "在航天领域，碳纤维多用作防热材料及结构功能一体化材料，可以大大减轻飞行器发射重量，节省发射费用及增加有效航程。中复神鹰SYT49S、SYT55S系列碳纤维优异的力学性能可以满足航天航空复合材料要求，在大型客机、通用飞机、运载火箭、商业卫星等领域有广阔的应用前景。",
        },
        {
          url: require("@/assets/images/useSlide02.jpg"),
          name: "风电叶片",
          info: "随着风力发电机功率增大，特别是在海上风机的需求刺激下，全球风机大型化的趋势日益明显。当风机变大后，全玻璃纤维叶片已无法满足叶片大型化、轻量化的要求，而密度、刚性方面更出色的碳纤维材料则成为了更理想的选择。在满足刚度和强度的前提下，碳纤维比玻璃纤维叶片质量轻30%以上。",
          info2:
            "中复神鹰SYT45S碳纤维拥有高比强度、高比拉伸模量等优良的特性、在风力发电领域拥有广阔的应用前景。",
        },
        {
          url: require("@/assets/images/useSlide03.jpg"),
          name: "碳/碳复合材料",
          info: "碳/碳复合材料产品由于其独特的性能，已广泛应用于航空航天、汽车工业、核能医学等领域。随着光伏装机量的不断提升，对单晶硅炉的需求也会呈现爆发性增长，碳/碳复合材料是目前最好的耐烧蚀材料之一，成为降低硅晶体制备成本、提高硅晶体质量的最优选择，正逐步形成在晶硅制造热场系统中对石墨材料部件的升级换代，未来拥有巨大市场空间。另外，碳/碳复材还可以用于刹车盘和机械密封等领域。",
          info2:
            "中复神鹰SYT49S碳纤维具有断裂伸长率长、表面光滑等特性，在立体编织和针刺成型中拥有优异的工艺性能和良好的尺寸精度，在高温环境中拥有低膨胀系数、低磨损率、耐热冲击等优异性能，已经在刹车盘和热场材料中大量使用。",
        },
        {
          url: require("@/assets/images/useSlide04.jpg"),
          name: "压力容器",
          info: "碳纤维缠绕气瓶因其重量轻、工艺性好、安全可靠和储存效率高等优势在压力容器领域具有广阔的应用前景，目前主要用于天然气和氢气储罐、高压储气罐、火箭发动机等领域。随着氢能应用的产业化发展，对压力容器用碳纤维需求的不断增长及国产碳纤维品质的不断提升，该领域的碳纤维应用前景广阔。",
          info2:
            "中复神鹰SYT49S碳纤维具有断裂伸长率长、表面光滑等特性，在立体编织和针刺成型中拥有优异的工艺性能和良好的尺寸精度，在高温环境中拥有低膨胀系数、低磨损率、耐热冲击等优异性能，已经在刹车盘和热场材料中大量使用。",
        },
        {
          url: require("@/assets/images/useSlide05.jpg"),
          name: "体育休闲",
          info: "碳纤维轻质、高强度、高模量、耐腐蚀的特性，在运动休闲、体育器材领域中拥有无可比拟的优势，已广泛应用于高尔夫球杆、网球拍、羽毛球拍、钓鱼竿、自行车、赛车、滑雪板、赛艇等领域。碳纤维复合材料使各种运动器材发生了革命性变化，人们可以在使用过程中获得非凡体验。碳纤维高尔夫球杆比金属杆减重近50%，碳纤维自行车较铝材减重40%且实现更高的车架精度。",
          info2:
            "中复神鹰SYT45S、SYT49S、SYT55S系列碳纤维可满足75g/m²以下密度的热熔型预浸料的制备工艺要求。在溶剂法预浸料制备中同样具有优异的表现、可满足55g/m²溶剂法预浸料的制备工艺要求。",
        },
        {
          url: require("@/assets/images/useSlide06.jpg"),
          name: "建筑桥梁",
          info: "碳纤维拥有优秀的抗老化、耐湿热、耐腐蚀性能，在全气候条件下不会降低可靠性。应用于桥梁、隧道、海工构筑物、非磁性建筑物等工程结构能够提升安全抗震性能，降低结构重量与容积。中复神鹰SYT49S碳纤维编织单向布的力学性能也能满足建筑补强一级布的要求（拉伸强度≥3400Mpa）。",
          info2: "",
        },
        {
          url: require("@/assets/images/useSlide07.jpg"),
          name: "汽车工业",
          info: "与金属材料相比，碳纤维复合材料在汽车整车和零部件上的使用可实现100-350公斤减重，碳纤维复合材料具有整体成型、可设计性强、减震性能良好等优点，是汽车轻量化的必由之路。当前，几乎所有的新能源汽车上均成功批量使用碳纤维复合材料，减重效果明显，性能提升显著。",
          info2:
            "中复神鹰拥有成熟的低成本碳纤维制备技术，在生产成本、力学性能和工艺性能方面均可满足汽车轻量化的需求。",
        },
        {
          url: require("@/assets/images/useSlide08.jpg"),
          name: "轨道交通",
          info: "与金属材料相比，碳纤维复合材料在汽车整车和零部件上的使用可实现100-350公斤减重，碳纤维复合材料具有整体成型、可设计性强、减震性能良好等优点，是汽车轻量化的必由之路。当前，几乎所有的新能源汽车上均成功批量使用碳纤维复合材料，减重效果明显，性能提升显著。",
          info2: "",
        },
        {
          url: require("@/assets/images/useSlide09.jpg"),
          name: "碳纤维电缆芯",
          info: "碳纤维复合芯电缆具有耐高温、载流量大、抗拉强度高、重量轻、弧垂小、节约杆塔费用及减少占地面积等一系列优点，由碳纤维芯棒、铝线外层组成，外层与邻外层铝线股为梯形截面。中复神鹰SYT49S碳纤维制造的复合芯导线抗拉强度可达到2400MPa，是常规的钢芯铝绞线抗拉强度的2倍。",
          info2: "",
        },
        {
          url: require("@/assets/images/useSlide10.jpg"),
          name: "电子3C",
          info: "计算机（Computer）、通信（Communication）、消费电子产品（Consumer Electronics）等“3C”电子产品目前朝着便携化、轻薄化发展。目前电子产品外壳和结构材料最常见的有金属材料、工程塑料、复合材料等，从轻量化的趋势和成本、工艺的考量，工程塑料、铝（镁）合金材料、碳纤维复合材料等材料的应用越来越广泛。",
          info2:
            "碳纤维复合材料轻、强的特点满足电子产品小、轻、便携化的发展趋势，在笔记本电脑、电视有着非常好的应用。而且，碳纤维复合材料还有导电、导热、X光透过性强、吸收电磁波等特殊性能，随着研究的深入，将有更多的应用。",
        },
      ],
    };
  },
  created() {
    this.lang = this.$global.lang;
  },
  props: ["slideList", "onSlide"],
  methods: {
    changeValue(value) {
      return changeText(value);
    },
  },
};
</script>

<style lang="scss">
.useSlideBox {
  position: relative;
  .slideInfo {
    position: absolute;
    bottom: 80px;
    left: 40%;
    width: 700px;
    // height: 350px;
    background: rgba(255, 255, 255, 0.9);
    padding: 20px;
    h3 {
      padding: 0 0 10px 0;
    }
    p {
      line-height: 30px;
      margin-bottom: 20px;
    }
  }
  .is-active {
    .el-carousel__button {
      background: #d71820;
    }
  }
  .imgBox {
    height: 100%;
  }
  .zixun {
    a {
      width: 150px;
      height: 53px;
      line-height: 53px;
      display: flex;
    
      align-items: center;
      justify-content: center;
      text-align: center;
      transition: all ease 0.3s;
      border: 1px solid #676767;
      img {
        width: 22px;
        height: 18px;
        margin-left: 10px;
        &.i2 {
          display: none;
        }
      }
    }
    .qrcode {
      width: 170px;
      height:230px;
      background: #fff;
      position: absolute;
      display:none;
      padding-bottom:25px;
      bottom:90px;
      box-shadow: 1px 9px 33px 0px rgba(51, 51, 51, 0.4);
      padding: 10px;
      img {
        width: 100%;
      }
      &::after{
        content:"";
        border:10px solid transparent;
        border-top:10px solid #fff;
        position: absolute;
        bottom:-20px;
        left:46%;
        transform: translateX(-50%);
      }
    }
    &:hover {
      .qrcode{
        display: block;
      }
      a {
        background: #c6322d;
        color: #fff;
        border-color: #c6322d;
        .i1 {
          display: none;
        }
        .i2 {
          display: block;
        }
      }
    }
  }
}
@media (max-width:768px) {
  .useSlideBox .zixun .qrcode{
    bottom:-5px;
  }
}
</style>
